// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@tailwind base;\r\n@tailwind components;\r\n@tailwind utilities;\r\n\r\n.gap-10px {\r\n  gap: 10px;\r\n}\r\n\r\n.gap-20px {\r\n  gap: 20px;\r\n}\r\n\r\n.w-full {\r\n  width: 100%;\r\n}\r\n\r\n.h-full {\r\n  height: 100%;\r\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
